import * as React from "react";
import Button from "../Button";
import { StartChatWidgetConfig } from "../../types";

interface Props {
  config: StartChatWidgetConfig;
  onStartChat(): void;
}

export default function StartChatWidget(props: Props) {
  if (!props.config || !props.config.Enabled) {
    return null;
  }

  return (
    <div className="landing-widget start-chat-widget">
      {props.config.SideImageUrl && (
        <>
          {props.config.SideImageGradientEnabled && (
            <div className="widget-gradient"></div>
          )}
          <div className="widget-side-img"></div>
        </>
      )}
      <div className="widget-body">
        <div className="widget-message">{props.config.LabelText}</div>
        <div className="widget-divider"></div>
        <div className="widget-form-container">
          <Button
            className="landing-widget-button"
            variant="primary"
            onClick={props.onStartChat}
          >
            {props.config.StartChatButtonLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
